import React from 'react';
import { useTranslation } from 'react-i18next';

import { formatAmount, fractionToPercent } from 'helpers/helpers';
import Grid from '@material-ui/core/Grid';
import H2 from 'apps/Pdf/components/common/H2';

import useGeneralStyles from 'apps/Pdf/styles/general';
import useStyles from './BucketStyle';
import { AmountValue } from 'common/interfaces';
import { Currency } from 'enums';

interface Props {
  className?: string;
  term?: 'long_term' | 'mid_term' | 'short_term' | 'default';
  data: { balance: AmountValue; profit: AmountValue, yearlyProfit: number };
  currency: Currency;
  active: boolean
}

const MiniBucket = (props: Props) => {
  const styles = useGeneralStyles();
  const classes = useStyles();
  const { t } = useTranslation();
  const { term, className, data, active } = props;

  return (
    <div className={`${classes.root} bgrLighter${className ? ' ' + className : ''}`}>
      <H2 className={term}>{t(`bucket.${props.term}.title`)} {!active && t('general_inactive')}</H2>
      <Grid container>
        {term !== 'default' && (
          <Grid item xs={12} className={styles.supplement}>
            {t(`bucket.${props.term}.subtitle`)}
          </Grid>
        )}
        <Grid item xs={12} className={`${styles.strongText} ${styles.right}`}>
          {data.balance !== undefined && formatAmount(data.balance, props.currency)}
        </Grid>
        <Grid item xs={12} className={styles.supplement}>
          aktuální hrubý zisk/ztráta
        </Grid>
        <Grid item xs={12} className={`${styles.strongText} ${styles.right}`}>
          {data.profit !== undefined && formatAmount(data.profit, props.currency)}
          {data.yearlyProfit !== undefined && data.yearlyProfit !== null && (
            <><br />({fractionToPercent(data.yearlyProfit, 2)} p. a.)</>
          )}
        </Grid>

      </Grid>
    </div>
  );
};

export default MiniBucket;
